import styled from '@emotion/styled'
import { DEFAULT_THEME_COLORS } from 'css/theme'

export const RecurringNudgeImage = styled.img`
  height: 44px;
  display: block;
  max-width: 100%;
`

export const RecurringNudgeText = styled.div({
  color: DEFAULT_THEME_COLORS['--theme-color--neutral-20'],
  display: 'inline',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  padding: '10px',
})
